import React from "react";
// import styled from 'styled-components'
// @mui
// 다국어
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
// component
import DefaultProfile from '../../image/default_profile.png'




const StyledSpan = styled('h3')(() => ({
    marginTop: '20px',
}));

const StyledPlan = styled('div')(() => ({
    backgroundColor: '#1a9ef8',
    color: 'white',
    fontSize: '1rem',
    padding: '0.5rem 0.5rem',
    borderRadius: '5px',
    margin: '0.5rem 0',
    lineHeight: 1,
}));




export default function ProfileComponent({ data }) {
    // 다국어
const { t, i18n } = useTranslation(['page']);



    const axiosData = data;
    // console.log('프로필', data.length);

    return (
        <>
            <div><img src={DefaultProfile} alt="Profile_img" /></div>
            <StyledSpan>{ !sessionStorage.getItem('login_info') ? null :  JSON.parse(sessionStorage.getItem('login_info')).user_name}</StyledSpan>
            {axiosData.length !== 0 && axiosData.use_license !== 'N/A' ? <StyledPlan>  {t(axiosData.use_license)} </StyledPlan> : null}
            <span>{axiosData.login_id}</span>
        </>
    );
}

